<template>
  <div class="c-spinner">

    <div v-if="spinner === spinnerRotatingPlane" class="sk-rotating-plane"></div>

    <div v-if="spinner === spinnerDoubleBounce">
      <div class="sk-child sk-double-bounce1"></div>
      <div class="sk-child sk-double-bounce2"></div>
    </div>

    <div v-if="spinner === spinnerWave" class="sk-wave">
      <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
    </div>

    <div v-if="spinner === spinnerWanderingCubes" class="sk-wandering-cubes">
      <div class="sk-cube sk-cube1"></div>
      <div class="sk-cube sk-cube2"></div>
    </div>

    <div v-if="spinner === spinnerPulse" class="sk-spinner sk-spinner-pulse"></div>

    <div v-if="spinner === spinnerChasingDots" class="sk-chasing-dots">
      <div class="sk-child sk-dot1"></div>
      <div class="sk-child sk-dot2"></div>
    </div>

    <div v-if="spinner === spinnerThreeBounce" class="sk-three-bounce">
      <div class="sk-child sk-bounce1"></div>
      <div class="sk-child sk-bounce2"></div>
      <div class="sk-child sk-bounce3"></div>
    </div>

    <div v-if="spinner === spinnerCircle" class="sk-circle">
      <div class="sk-circle1 sk-child"></div>
      <div class="sk-circle2 sk-child"></div>
      <div class="sk-circle3 sk-child"></div>
      <div class="sk-circle4 sk-child"></div>
      <div class="sk-circle5 sk-child"></div>
      <div class="sk-circle6 sk-child"></div>
      <div class="sk-circle7 sk-child"></div>
      <div class="sk-circle8 sk-child"></div>
      <div class="sk-circle9 sk-child"></div>
      <div class="sk-circle10 sk-child"></div>
      <div class="sk-circle11 sk-child"></div>
      <div class="sk-circle12 sk-child"></div>
    </div>

    <div v-if="spinner === spinnerCubeGrid" class="sk-cube-grid">
      <div class="sk-cube sk-cube1"></div>
      <div class="sk-cube sk-cube2"></div>
      <div class="sk-cube sk-cube3"></div>
      <div class="sk-cube sk-cube4"></div>
      <div class="sk-cube sk-cube5"></div>
      <div class="sk-cube sk-cube6"></div>
      <div class="sk-cube sk-cube7"></div>
      <div class="sk-cube sk-cube8"></div>
      <div class="sk-cube sk-cube9"></div>
    </div>

    <div v-if="spinner === spinnerFadingCircle" class="sk-fading-circle">
      <div class="sk-circle1 sk-circle"></div>
      <div class="sk-circle2 sk-circle"></div>
      <div class="sk-circle3 sk-circle"></div>
      <div class="sk-circle4 sk-circle"></div>
      <div class="sk-circle5 sk-circle"></div>
      <div class="sk-circle6 sk-circle"></div>
      <div class="sk-circle7 sk-circle"></div>
      <div class="sk-circle8 sk-circle"></div>
      <div class="sk-circle9 sk-circle"></div>
      <div class="sk-circle10 sk-circle"></div>
      <div class="sk-circle11 sk-circle"></div>
      <div class="sk-circle12 sk-circle"></div>
    </div>

    <div v-if="spinner === spinnerFoldingCube" class="sk-folding-cube">
      <div class="sk-cube1 sk-cube"></div>
      <div class="sk-cube2 sk-cube"></div>
      <div class="sk-cube4 sk-cube"></div>
      <div class="sk-cube3 sk-cube"></div>
    </div>
  </div>
</template>

<script>
  const spinnerRotatingPlane = 'rotatingPlane'
  const spinnerDoubleBounce = 'doubleBounce'
  const spinnerWave = 'wave'
  const spinnerWanderingCubes = 'wanderingCubes'
  const spinnerPulse = 'pulse'
  const spinnerThreeBounce   = 'threeBounce'
  const spinnerCircle  = 'circle'
  const spinnerCubeGrid  = 'cubeGrid'
  const spinnerFadingCircle = 'fadingCircle'
  const spinnerFoldingCube = 'foldingCube'
  const spinnerChasingDots = 'chasingDots'
  export default {
    name: 'Spinner',
    props: {
      spinner: {
        type: String,
        default: 'circle'
      }
    },
    mounted() {
    },
    data: () => {
      return {
        spinnerRotatingPlane:spinnerRotatingPlane,
        spinnerDoubleBounce:spinnerDoubleBounce,
        spinnerWanderingCubes:spinnerWanderingCubes,
        spinnerPulse:spinnerPulse,
        spinnerThreeBounce:spinnerThreeBounce,
        spinnerCircle:spinnerCircle,
        spinnerCubeGrid:spinnerCubeGrid,
        spinnerFadingCircle:spinnerFadingCircle,
        spinnerFoldingCube:spinnerFoldingCube,
        spinnerWave:spinnerWave,
        spinnerChasingDots:spinnerChasingDots
      }
    }
  }
</script>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style scoped>
  .sk-fading-circle .sk-circle {
    margin: 0 auto;
  }
  .sk-three-bounce {
    height: 40px;
  }
</style>
